import { useEffect, useState } from 'react';

import { Alert, Button, Typography } from '@mui/material';
import { useOktaAuth } from '@okta/okta-react';
import { useHistory, useLocation } from 'react-router-dom';

import { ReactComponent as RabbitLogo } from 'assets/SVGs/logo.svg';
import { ConsentBanner } from 'components/ConsentBanner';
import { settings } from 'config';

import { Background } from '../styledComponents';
import {
  AuthText,
  AuthContentWrapper,
  AuthLogoWrapper,
  AuthComponents,
  AuthComponentWrapper,
} from './styledComponents';

export const Authentication: React.FC = () => {
  const { oktaAuth } = useOktaAuth();
  const login = () =>
    oktaAuth.signInWithRedirect({
      originalUri: settings.APP_ORIGINAL_URI + '/home',
    });
  const location = useLocation();
  const history = useHistory();
  const logoutMessage = 'User logged out successfully';
  const [stateParam, setStateParam] = useState<string | null>('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('state') !== null) {
      setStateParam(params.get('state'));
    }

    const timerId = setTimeout(() => {
      history.replace({ search: '' });
      setStateParam('');
    }, 2000);
    return () => clearTimeout(timerId);
  }, [history, location.search]);

  return (
    <>
      {stateParam === '' && <ConsentBanner />}
      <Background>
        <AuthLogoWrapper>
          <RabbitLogo />
          <Typography
            variant='h4'
            noWrap
            component='div'
            align='center'
            sx={{
              mr: 2,
              ml: 2,
              letterSpacing: '.2em',
              display: { md: 'flex' },
              color: 'white',
              alignItems: 'center',
            }}
          >
            RABBIT
          </Typography>
        </AuthLogoWrapper>
        <AuthContentWrapper>
          <AuthComponents>
            <AuthComponentWrapper sx={{ alignItems: 'flex-end' }}>
              <AuthText>
                <h5>Welcome to Rabbit</h5>
                <p>
                  Rabbit helps employers to verify employment of people who
                  worked for the DOW in support of Operation Enduring Freedom.
                </p>
              </AuthText>
              <AuthComponentWrapper sx={{ alignItems: 'flex-end' }}>
                <AuthText>
                  {stateParam === 'logged_out' && (
                    <Alert severity='success'>
                      <Typography variant='h6'>{logoutMessage}</Typography>
                    </Alert>
                  )}

                  <Typography>
                    Click the login button to authenticate
                  </Typography>
                  <Button variant='contained' onClick={login}>
                    Login
                  </Button>
                </AuthText>
              </AuthComponentWrapper>
            </AuthComponentWrapper>
          </AuthComponents>
        </AuthContentWrapper>
      </Background>
    </>
  );
};
